var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tabs-wrap"
  }, [_c('v-tabs', {
    attrs: {
      "grow": ""
    }
  }, [_c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/mypage/cart/single"
    }
  }, [_vm._v("일반배송(" + _vm._s(_vm.summary.singleCartTotalCount) + ")")]), _c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/mypage/cart/regular"
    }
  }, [_vm._v("정기배송(" + _vm._s(_vm.summary.regularCartTotalCount) + ")")]), _c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/mypage/cart/stock"
    }
  }, [_vm._v("재고주문(" + _vm._s(_vm.summary.stockCartTotalCount) + ")")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }